import envConfig from "/public/static/json/env-config.json";

// Api configuration
export default {
  baseUrl: process.env.VUE_APP_API_BASEURL,
  version2: 'v2',
  version3: 'v3'
}
